/* eslint-disable-next-line import/prefer-default-export */
export const SAVE_TAGS = 'SAVE_TAGS';
